import React from 'react';
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { Alert } from "react-bootstrap";
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';

class WarningDocumentReply extends BaseDocument {
    constructor(props) {
        super(props);

        this.replyFormConfig = {
            fields: [
                { resource: "CONTRACT.WF.EW.FIELD.NO_REPLY", dataField: 'replystatus', editorType: 'dxCheckBox' },
                { resource: "GENERAL.FORMS.FIELD.COMMENTS", dataField: 'replycomment', editorType: 'dxHtmlEditor', visible: (obj) => !obj.replystatus },
            ]
        };

    }

    renderForm = () => {
        return (
            <BiDynamicForm
                isReply={true}
                item={this.props.reply}
                config={this.replyFormConfig}
                valueChangeHandler={this.props.fieldChanged}
                customFields={(this.props.customFields || {}).REPLY}
            />
        );
    }
    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType + 'Reply', this.props.notification.warningid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }
    render() {
        const documentIsFinal = !this.props.isAwaitingReply;
        const { replycreatebyname, replycreatedate, draftreplyby, draftreplydate, draftreplyto } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={replycreatebyname}
                    createdate={replycreatedate}
                    lastdraftedbyname={draftreplyby}
                    lastdrafteddate={draftreplydate}
                    lastdraftednotifiedtoname={draftreplyto}
                    isReply={true}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfreplyjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    // notifyDate={documentIsFinal ? this.props.notification.replydate : new Date()}
                    // bodyConfig={documentIsFinal ? this.documentBodyConfig() : null}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    isReply={true}
                    customFields={(this.props.customFields || {}).REPLY}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>
        );

    }
}



export default injectIntl(WarningDocumentReply);
